import { useState, useEffect } from 'react';

import { Tag } from '@zola/zola-ui/src/components/Tag';

import PropTypes from 'prop-types';

import { addItemToCart } from '@/actions/CartActions';
import { onAddToCart } from '@/pages/ProductDetailPage/onAddToCart';

import { getProductClickedEventData, setSkuAttributes } from './helpers';
import { getKitProductAddedEventData } from './pdpHelpers';
import ProductOverviewRow from './ProductOverviewRow';
import { getProductImage } from '../../util/productHelper';
import { resolveMatchingSku } from '../../util/resolveMatchingSku';
import { trackProductAdded, trackProductClicked } from '../../util/trackingHelper';
import './ProductOverviewRow.less';

const ProductDetailRow = (props) => {
  const { productData, dispatch, userContext, location, section, position, collectionEventData } =
    props;
  const [activeSku, setActiveSku] = useState();
  const [activeProductLook, setActiveProductLook] = useState();
  const [productAttributes, setProductAttributes] = useState({});
  const [quantity, setQuantity] = useState();

  // TODO: this is duplicated in ProductDetailPage.jsx, we should figure out how to share between the components
  useEffect(() => {
    // set the active product look
    const productLooks = productData.product_look_views;
    const selectedProductLook = productLooks[0];
    setActiveProductLook(selectedProductLook);

    // resolve the active SKU
    setActiveSku(resolveMatchingSku(selectedProductLook.sku_previews, {}));

    // initialize quantity
    setQuantity(productData.suggested_quantity);
  }, []);

  useEffect(() => {
    if (activeSku) {
      setSkuAttributes(setProductAttributes, productData, activeSku);
    }
  }, [activeSku]);

  const addToCartCallback = (response) => {
    if (response && response.payload) {
      const { payload } = response;
      const eventData = getKitProductAddedEventData({
        productData,
        activeProductLook,
        activeSku,
        quantity,
        cartId: payload.cart_id,
        location,
        section,
        position,
      });
      trackProductAdded(eventData);
    }
    window.dispatchEvent(new CustomEvent('OPEN_MODAL_EVENT', { detail: 'CART' }));
  };

  const addToCartParams = { activeSku, quantity, setQuantity, dispatch, addItemToCart };

  const personalizationAvailable = productData && productData.personalizable;

  const personalizeBadge = personalizationAvailable && (
    <Tag
      type="emoji"
      size="lg"
      className="personalize-banner"
      emoji={{ ariaLabel: 'pencil emoji', symbol: '✏️' }}
    >
      Personalizable
    </Tag>
  );

  const personalizeMessage = !activeSku && personalizationAvailable && (
    <p className="personalize-message">Go to item details to personalize</p>
  );
  const handleAddToCart = onAddToCart(addToCartParams, addToCartCallback);

  /**
   * Redirects user to PDP of the selected product
   * @param {boolean} shouldOpenModal - flag used to set url param for PDP to open
   * personalization modal after page is loaded
   */
  const onPdpRedirect = (shouldOpenModal) => {
    const eventData = getProductClickedEventData(
      productData,
      activeProductLook,
      activeSku,
      quantity,
      location,
      section,
      position
    );
    trackProductClicked(eventData);
    let urlParams = '';
    if (activeSku && activeSku.id) {
      urlParams = `?skuId=${activeSku.id}`;
      if (shouldOpenModal === true) {
        urlParams = `${urlParams}&show_modal=true`;
      }
    }
    window.location = `/shop/product/${activeProductLook.key}${urlParams}`;
  };
  const productImage = getProductImage(activeProductLook, 'large', false);
  return (
    <div className="product-detail-row_container">
      <div className="product-detail-row-image">
        {personalizeBadge}
        <img onClick={onPdpRedirect} alt={productData.display_name} src={productImage} />
        {personalizeMessage}
      </div>
      <ProductOverviewRow
        productData={productData}
        activeProductLook={activeProductLook}
        setActiveProductLook={setActiveProductLook}
        productAttributes={productAttributes}
        setProductAttributes={setProductAttributes}
        quantity={quantity}
        setQuantity={setQuantity}
        setActiveSku={setActiveSku}
        activeSku={activeSku}
        onPdpRedirect={onPdpRedirect}
        handleAddToCart={handleAddToCart}
        location={location}
        section={section}
        collectionEventData={collectionEventData}
        userContext={userContext}
      />
    </div>
  );
};

ProductDetailRow.propTypes = {
  productData: PropTypes.shape({}),
  dispatch: PropTypes.func,
  userContext: PropTypes.shape({}),
  location: PropTypes.string,
  section: PropTypes.string,
  position: PropTypes.number,
  collectionEventData: PropTypes.shape({
    collection_key: PropTypes.string,
    collection_name: PropTypes.string,
  }),
};

export default ProductDetailRow;
